import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [mixFormatoEstructura],
  data() {
    return {
      fianzas: [
        { id: 1, nombre: 'cumplimiento' },
        { id: 2, nombre: 'anticipo' },
        { id: 3, nombre: 'viciosocultos' },
      ],
      tiposFechas: [
        {
          id: 'fecha-de-entrega-de-proyecto',
          name: 'fechaEntregaProyecto',
        },
        {
          id: 'fecha-de-entrega-de-sitio',
          name: 'fechaEntregaSitio',
        },
        {
          id: 'fecha-aviso-de-terminacion',
          name: 'fechaAvisoTerminacion',
        },
        {
          id: 'fecha-de-verificacion-de-los-trabajos',
          name: 'fechaVerificacionTrabajos',
        },
        {
          id: 'fecha-de-recepcion-de-trabajos',
          name: 'fechaRecepcionTrabajos',
        },
        {
          id: 'fecha-de-cierre-de-bitacora',
          name: 'fechaCierreBitacora',
        },
        {
          id: 'fecha-de-acta-finiquito',
          name: 'fechaActaFiniquito',
        },
        {
          id: 'fecha-de-acta-de-extincion',
          name: 'fechaActaExtincion',
        },
        {
          id: 'fecha-de-entrega-de-obra',
          name: 'fechaEntregaObra',
        },
        {
          id: 'fecha-de-suspension-de-trabajos',
          name: 'fechaSuspensionTrabajos',
        },
        {
          id: 'fecha-de-reinicio-de-trabajos',
          name: 'fechaReinicioTrabajos',
        },
        {
          id: 'fecha-solicitud-terminacion-anticipada',
          name: 'fechaSolicitudTerminacionAnticipada',
        },
        {
          id: 'fecha-de-terminacion-anticipada',
          name: 'fechaTerminacionAnticipada',
        },
        {
          id: 'fecha-inicio-de-rescision-administrativa',
          name: 'fechaInicioRescisionAdministrativa',
        },
        {
          id: 'fecha-de-resciscion-administrativa',
          name: 'fechaRescisionAdministrativa',
        },
      ],
    };
  },
  computed: {
    integraContratoFechas() {
      if (!this.fechas) return [];
      const contratoFechasMap = new Map();
      this.tiposFechas
        .map((tipo) => {
          const fechaTipo = this.fechas
            .filter((fecha) => (fecha.tipo === tipo.id ? fecha.fecha : false));
          if ((tipo.id === 'fecha-de-suspension-de-trabajos'
          || tipo.id === 'fecha-de-reinicio-de-trabajos')) {
            contratoFechasMap.set(tipo.name, fechaTipo);
          } else if (fechaTipo.length > 0) {
            contratoFechasMap.set(tipo.name, fechaTipo[0].fecha);
          } else {
            contratoFechasMap.set(tipo.name, '');
          }
          return true;
        });
      return Object.fromEntries(contratoFechasMap);
    },
  },
  methods: {

    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto, true, true);
    },
    formatoWordContrato(contrato) {
      if (!contrato || typeof (contrato) !== 'object') return {};
      const contratoMap = new Map();
      let buscaFianza = {};
      let residente = '';
      let supervisionExterna = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(contrato)) {
        switch (key) {
          case 'fianzas':
            if (!value) { break; }
            // eslint-disable-next-line no-loop-func
            value.forEach((f) => {
              buscaFianza = this.fianzas.find((tf) => tf.id === f.tipo) ? this.fianzas.find((tf) => tf.id === f.tipo) : '';
              contratoMap.set(`fianza_${buscaFianza.nombre}`, {
                fecha: f.fecha,
                monto: f.monto,
                nombreAfianzadora: f.nombreAfianzadora,
                numero: f.numero,
              });
            });

            this.fianzas.forEach((fianza) => {
              if (!contratoMap.has(`fianza_${fianza.nombre}`)) {
                contratoMap.set(`fianza_${fianza.nombre}`, {
                  fecha: '',
                  monto: null,
                  nombreAfianzadora: '',
                  numero: '',
                });
              }
            });

            break;
          case 'anticipos':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  fecha: '',
                  importe: 0,
                  iva: 0,
                  total: 0,
                  porcentaje: 0,
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'convenios':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  tipo: '',
                  numero: '',
                  fecha: '',
                  importe: 0,
                  iva: 0,
                  total: 0,
                  fechaInicio: '',
                  fechaTermino: '',
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'estimaciones':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  numero: '',
                  fechaDel: '',
                  fechaAl: '',
                  porcentajeIva: 0,
                  importeEstimado: 0,
                  importeRetenido: 0,
                  importeDevuelto: 0,
                  importeNeto: 0,
                  importeAmortizacionAnticipo: 0,
                  importeDeducciones: 0,
                  subtotal: 0,
                  importeIva: 0,
                  totalFactura: 0,
                  importeBonificacion: 0,
                  importeSancion: 0,
                  importeLiquido: 0,
                  bonificacionDetalle: 0,
                  esEstimacionFinPrograma: '',
                  esEstimacionFiniquito: '',

                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'superintendentes':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  nombreCompleto: '',
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'plazo':
            contratoMap.set(key, `${value}`);
            break;
          case 'responsables':
            residente = value.filter((r) => r.principal === true)[0]
              ? value.filter((r) => r.principal === true)
                .map((r) => r.funcionario.nombre)[0] : '';
            contratoMap.set('residente', residente);
            break;
          case 'contratosRelacionados':
            supervisionExterna = value.filter((c) => c.esSupervisionExterna === true)[0]
              ? value.filter((c) => c.esSupervisionExterna === true)
                .map((c) => c.contratoRelacionado.contratista)[0] : '';
            contratoMap.set('supervisionExternaRepresentante', supervisionExterna.nombreRepresentante || '');
            contratoMap.set('supervisionExternaRazonSocial', supervisionExterna.nombreRazonSocial || '');
            break;
          default:
            if (!value && value !== 0) { contratoMap.set(key, ''); break; }
            contratoMap.set(key, value);
            break;
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.integraContratoFechas)) {
        contratoMap.set(key, value);
      }
      return this.formatoObjeto(Object.fromEntries(contratoMap));
    },
  },
};
